import React from 'react';
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {withStyles} from "@material-ui/styles";
import MuiTable from "../common/MuiTable";
import {
    approvedSupplierList, deleteApprovedSupplierList,
    saveOrUpdateApprovedSupplierList, exportReport, approvedSupplierListRevision, uploadFile, importFile,
} from "../../util/ApiUtils";
import {NotificationManager, NotificationContainer} from "react-notifications";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import {Spinner} from "../common/Spinner";
import DocumentControlHeader from "./ApprovedSupplierListDocumentControlHeader";
import * as CommonUtils from "../../util/CommonUtils";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { t } from '../../i18n';

const classes = ((theme) => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const columns = [
    {
        title: t('context.common.id'),
        field: 'id',
        type: "numeric",
        hidden: true,
    },
    {
        title: t('operation.approvedSupplierList.columns.supplierName'),
        field: 'name',
        type: "string",
        cellStyle: {
            width: '12%'
        }
    },
    {
        title: t('operation.approvedSupplierList.columns.contactName'),
        field: 'contactName',
        type: "string",
        cellStyle: {
            width: '12%'
        }
    },
    {
        title: t('operation.approvedSupplierList.columns.contactPhoneNumber'),
        field: 'contactPhoneNumber',
        type: "string",
        cellStyle: {
            width: '12%'
        }
    },
    {
        title: t('operation.approvedSupplierList.columns.address'),
        field: 'address',
        type: "string",
        cellStyle: {
            width: '12%'
        }
    },
    {
        title: t('operation.approvedSupplierList.columns.productService'),
        field: 'productService',
        type: "string",
        cellStyle: {
            width: '15%'
        }
    },
    {
        title: t('operation.approvedSupplierList.columns.complaints'),
        field: 'complaints',
        type: "string",
        cellStyle: {
            width: '12%'
        }
    },
    {
        title: t('operation.approvedSupplierList.columns.onTimeOnBudget'),
        field: 'onTimeOnBudget',
        type: "string",
        cellStyle: {
            width: '12%'
        }
    },
    {
        title: t('operation.approvedSupplierList.columns.reworkRequired'),
        field: 'reworkRequired',
        type: "string",
        cellStyle: {
            width: '12%'
        }
    },
    {
        title: t('operation.approvedSupplierList.columns.approvedSupplier'),
        field: 'isApproved',
        lookup: { yes : t('common.yes') , no : t('common.no') },
    },
];

class ApprovedSupplierList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            approvedSupplierList: [],
            isLoading: true,
        };
        this.loadApprovedSupplierList = this.loadApprovedSupplierList.bind(this);
        this.handleSaveOrUpdate = this.handleSaveOrUpdate.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.isValid = this.isValid.bind(this);
        this.onYearSelected = this.onYearSelected.bind(this);
        this.onFileImport = this.onFileImport.bind(this);
        this.fileUploadHandler = this.fileUploadHandler.bind(this);
    }

    componentDidMount() {
        const selectedYear = moment(new Date()).format('YYYY');
        this.setState({
            selectedYear: selectedYear,
        });
        this.loadApprovedSupplierList(selectedYear);
    }

    onYearSelected(event, selectedYear) {
        this.setState({
            selectedYear: selectedYear,
        });
        this.loadApprovedSupplierList(selectedYear);
    }

    loadApprovedSupplierList(selectedYear) {
        approvedSupplierList()
            .then(response => {
                console.log(response);
                let suppliersThisYear = response.filter(function(approvedSupplier) {
                    return approvedSupplier.approvedYear === parseInt(selectedYear);
                });
                this.setState({
                    approvedSupplierList: suppliersThisYear,
                });
                approvedSupplierListRevision()
                    .then(response => {
                        this.setState({
                            latestRevision: response,
                            isLoading: false,
                        });
                    })
                    .catch(error => {
                        console.log(error);
                    });
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleSaveOrUpdate(approvedSupplierListRequest) {
        approvedSupplierListRequest.approvedYear = this.state.selectedYear;
        saveOrUpdateApprovedSupplierList(approvedSupplierListRequest)
            .then(() => {
                this.loadApprovedSupplierList(this.state.selectedYear);
                window.location.reload()
                NotificationManager.success(t('app.notifications.success'), t('operation.approvedSupplierList.updated'), 5000);
            }).catch(error => {
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    onFileImport(event) {
        console.log('event.target.files[0]', event.target.files[0]);
        this.setState({
            selectedFile: event.target.files[0],
        });
    }

    fileUploadHandler() {
        importFile(
            "/approved-supplier-list/import",
            this.state.selectedFile,
            [{currentYear: this.state.selectedYear}]);
    }
    handleDelete(approvedSupplierListRequest) {

        deleteApprovedSupplierList(approvedSupplierListRequest)
            .then(() => {
                NotificationManager.success(t('app.notifications.success'), t('operation.approvedSupplierList.updated'), 5000);
                window.location.reload();
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    isValid(newData) {
        let isValid = newData.name && newData.name !== '';
        if (!isValid) {
            NotificationManager.error(t('app.notifications.error'), t('operation.approvedSupplierList.validation.supplierNameRequired'), 5000);
        }
        return isValid;
    }

    render() {
        let { state } = this;
        let { classes } = this.props;
        if (state.isLoading) {
            return <Spinner/>;
        }
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        return <div>
            <Typography component="h2" variant="h5">
                <div style={{float: 'left'}}>{ t('operation.approvedSupplierList.title') }</div>
            </Typography>
            <DocumentControlHeader revision={state.latestRevision} isReadOnly={isDemo || isAuditor || isViewer}>
                <Paper className={classes.root} style={{ marginTop: '30px' }}>
                    <MuiTable
                        title={
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                    style={{float: 'right'}}
                                    disableToolbar
                                    autoOk
                                    variant="inline"
                                    format="YYYY"
                                    margin="normal"
                                    id="selectedYear"
                                    label={ t('context.common.filterByYear') }
                                    name="selectedYear"
                                    value={state.selectedYear}
                                    views={['year']}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    onChange={ this.onYearSelected}
                                />
                            </MuiPickersUtilsProvider>
                        }
                        columns={columns}
                        data={state.approvedSupplierList}
                        onAdd={this.handleSaveOrUpdate}
                        onUpdate={this.handleSaveOrUpdate}
                        onDelete={this.handleDelete}
                        exportButton={!isDemo && !isViewer}
                        onExport={() => exportReport('/approved-supplier-list/export')}
                        isValid={this.isValid}
                        allowUpdateDelete={(isAuditor || isViewer) ? 'no' : 'yes'}
                    />
                </Paper>
                {(this.props.isAuthenticated && ['admin@statuo.com.au', 'tanya.happy@live.com'].includes(this.props.currentUser.username)) &&
                    <div>
                        <h4>{ t('operation.approvedSupplierList.importData') }</h4>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="file"
                            name="file"
                            autoFocus
                            disabled={isAuditor || isViewer}
                            onChange={this.onFileImport}
                            type="file"
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            onClick={() => this.fileUploadHandler()}
                        >
                            { t('operation.approvedSupplierList.importButton') }
                        </Button>
                    </div>
                }
            </DocumentControlHeader>
            <NotificationContainer/>
        </div>;
    }
}

export default withStyles(classes)(ApprovedSupplierList);